import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./Footer";
import InputBroadCastMessage from "../components/Inputs/InputBroadCastMessage";
import BotaoBroadCast from "../components/Botoes/BotaoBroadCast";
import { LoaderCircle, SendHorizonal } from "lucide-react";
import axios from "axios";

export default function BroadCast() {
    const { id } = useParams();
    const [message, setMessage] = useState("");
    const [statusMessageSender, setStatusMessageSender] = useState(false)
    const [sending, setSending] = useState(false)

    async function sendMessage() {
        try {
            setSending(true)
            const sendMessage = await axios.post("http://localhost:8002/broadcast",
                {
                    "messageBody": message
                }
            )
            if (sendMessage) {
                setStatusMessageSender("Mensagens Enviadas")
                console.log("Mensagem Enviada com Sucesso!")

            } else {
                setStatusMessageSender("houve algum problem ao enviar a Mensagem")
                console.log("Houve algum erro ao enviar as Mensagens")
            }
        } catch (erro) {
            console.log(erro)
        } finally {
            setSending(false)
        }
    }

    useEffect(() => {
        // Pode ser usado para buscar dados relacionados ao id no futuro
    }, [id]);

    const propsInputBrodCast = {
        type: "textarea",
        placeholder: "Digite sua mensagem de broadcast...",
        mudar: (e) => setMessage(e.target.value),
    };
    const propsButtonBrodCast = {
        type: "submit",
        texto:
            <span className="flex text-xl items-center justify-center gap-2">
                Enviar
            </span>
    };
    const propsButtonBrodCastSending = {
        texto:
            <span className="flex text-xl items-center justify-center gap-2">
                Enviando <LoaderCircle className="animate-spin" />
            </span>
    };

    return (
        <div className="flex flex-col justify-between min-h-screen bg-gray-100">
            <div className="bg-blue-600 shadow-md">
                <NavBar />
            </div>

            <div className="flex-grow flex flex-col items-center justify-center p-4">
                <div className="w-full max-w-3xl bg-white p-6 rounded-2xl shadow-lg">
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4 text-center">
                        Enviar Broadcast para Clientes
                    </h2>
                    <p className="text-sm text-gray-500 mb-6 text-center">
                        Insira abaixo a mensagem que será enviada para todos os clientes cadastrados.
                    </p>

                    <div className="mb-4">
                        <InputBroadCastMessage {...propsInputBrodCast} />
                    </div>
                    <div>
                        {
                            sending ?
                                <div>
                                    <BotaoBroadCast clicado={() => {
                                    }} {...propsButtonBrodCastSending} />
                                </div> :
                                <div>
                                    <BotaoBroadCast clicado={() => {
                                        sendMessage()
                                    }} {...propsButtonBrodCast} />
                                </div>
                        }                       
                    </div>
                </div>
            </div>

            <div className="bg-blue-600">
                <Footer />
            </div>
        </div>
    );
}
